// src/components/RevenueCatSync.tsx
// Monté une fois dans l'app. Sur mobile natif :
//  - configure le SDK RevenueCat au boot
//  - lie / délie l'utilisateur RevenueCat au fil des changements de session Supabase
// Ne rend rien. No-op complet sur le web.

import { useEffect } from "react";
import { supabase } from "../supabaseClient";
import {
  isNativeBilling,
  initRevenueCat,
  identifyRevenueCat,
  logoutRevenueCat,
} from "../lib/billing";

export default function RevenueCatSync() {
  useEffect(() => {
    if (!isNativeBilling()) return;

    let cancelled = false;

    (async () => {
      await initRevenueCat();
      const { data } = await supabase.auth.getUser();
      if (cancelled) return;
      if (data.user?.id) await identifyRevenueCat(data.user.id);
    })();

    const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "SIGNED_OUT" || !session?.user) {
        void logoutRevenueCat();
      } else if (session.user?.id) {
        void identifyRevenueCat(session.user.id);
      }
    });

    return () => {
      cancelled = true;
      sub.subscription?.unsubscribe();
    };
  }, []);

  return null;
}
